<template>
    <div class="page-wrapper">
        <v-snackbar
                v-model="notification"
                :color="notification_type"
                :timeout="5000"
                :top="true"
        >
            {{ notification_message }}
            <v-btn
                    text
                    @click="notification = false"
            >
                Close
            </v-btn>
        </v-snackbar>

        <v-container
                fill-height
                fluid
                grid-list-xl>
            <v-layout
                    justify-center
                    wrap>
                <v-flex
                        xs12
                        md12
                >
                    <v-data-table
                            :headers="headers"
                            :items.sync="promotions"
                            :page.sync="page"
                            :server-items-length="totalItems"
                            :items-per-page="itemsPerPage"
                            hide-default-footer
                            @page-count="pageCount = $event"
                            sort-by="calories"
                            class="elevation-1"
                    >
                        <template v-slot:top>
                            <v-toolbar flat color="white">
                                <v-toolbar-title>Promotions</v-toolbar-title>
                                <v-divider
                                        class="mx-4"
                                        inset
                                        vertical
                                ></v-divider>
                                <v-spacer></v-spacer>
                                <v-dialog v-model="dialog" :persistent="true" max-width="500px">
                                    <template v-slot:activator="{ on }">
                                        <v-btn color="blue-grey darken-4" dark class="mb-2" v-on="on">New Promotions</v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-title>
                                            <span class="headline">{{ formTitle }}</span>
                                        </v-card-title>

                                        <v-card-text>
                                            <v-container grid-list-md>
                                                <v-layout wrap>
                                                    <v-flex xs12>
                                                        <v-text-field v-model="editedItem.name"
                                                                      required
                                                                      :error-messages="checkName"
                                                                      @input="$v.editedItem.name.$touch()"
                                                                      @blur="$v.editedItem.name.$touch()"
                                                                      label="Name"></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs12>
                                                        <v-select
                                                                v-model="editedItem.type"
                                                                :items="promo_types"
                                                                required
                                                                :error-messages="checkType"
                                                                @input="$v.editedItem.type.$touch()"
                                                                @blur="$v.editedItem.type.$touch()"
                                                                item-value="id"
                                                                item-text="name"
                                                                label="Type"
                                                        ></v-select>
                                                    </v-flex>
                                                    <v-flex xs12>
                                                        <v-text-field
                                                                v-model="editedItem.amount"
                                                                required
                                                                type="number"
                                                                :error-messages="checkAmount"
                                                                @input="$v.editedItem.amount.$touch()"
                                                                @blur="$v.editedItem.amount.$touch()"
                                                                label="Amount"
                                                        ></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs12>
                                                        <v-menu
                                                                ref="menu1"
                                                                v-model="menu1"
                                                                :close-on-content-click="false"
                                                                transition="scale-transition"
                                                                offset-y
                                                                full-width
                                                                max-width="290px"
                                                                min-width="290px"
                                                        >
                                                            <template v-slot:activator="{ on }">
                                                                <v-text-field
                                                                        v-model="editedItem.run_from"
                                                                        autocomplete="off"
                                                                        label="Run From"
                                                                        hint="MM/DD/YYYY format"
                                                                        required
                                                                        :error-messages="checkRunFrom"
                                                                        @input="$v.editedItem.run_from.$touch()"
                                                                        @blur="$v.editedItem.run_from.$touch()"
                                                                        persistent-hint
                                                                        prepend-icon="mdi-calendar"
                                                                        v-on="on"
                                                                ></v-text-field>
                                                            </template>
                                                            <v-date-picker v-model="editedItem.run_from" no-title
                                                                           @input="menu1 = false"></v-date-picker>
                                                        </v-menu>
                                                    </v-flex>
                                                    <v-flex xs12>
                                                        <v-menu
                                                                v-model="menu2"
                                                                :close-on-content-click="false"
                                                                transition="scale-transition"
                                                                offset-y
                                                                full-width
                                                                max-width="290px"
                                                                min-width="290px"
                                                        >
                                                            <template v-slot:activator="{ on }">
                                                                <v-text-field
                                                                        autocomplete="off"
                                                                        v-model="editedItem.run_to"
                                                                        label="Run To"
                                                                        required
                                                                        :error-messages="checkRunTo"
                                                                        @input="$v.editedItem.run_to.$touch()"
                                                                        @blur="$v.editedItem.run_to.$touch()"
                                                                        hint="MM/DD/YYYY format"
                                                                        persistent-hint
                                                                        prepend-icon="mdi-calendar"
                                                                        v-on="on"
                                                                ></v-text-field>
                                                            </template>
                                                            <v-date-picker v-model="editedItem.run_to" no-title
                                                                           @input="menu2 = false"></v-date-picker>
                                                        </v-menu>
                                                    </v-flex>
                                                    <v-flex xs12>
                                                        <v-select
                                                                v-model="editedItem.products"
                                                                :items="products"
                                                                multiple
                                                                :menu-props="{closeOnClick:true, closeOnContentClick:true}"
                                                                chips
                                                                item-value="id"
                                                                item-text="name"
                                                                label="Products"
                                                        ></v-select>
                                                    </v-flex>

                                                </v-layout>
                                            </v-container>
                                        </v-card-text>

                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                                            <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-toolbar>
                        </template>
                        <template v-slot:item.action="{ item }">
                            <v-btn
                                    color="blue-grey darken-4"
                                    @click="editItem(item)"
                            >
                                <v-icon>
                                    mdi-pencil
                                </v-icon>
                            </v-btn>
                            <v-btn
                                    class="mx-2"
                                    color="blue-grey darken-4"
                                    @click="deleteItem(item)"
                            >
                                <v-icon>
                                    mdi-delete
                                </v-icon>
                            </v-btn>
                        </template>
                        <template v-slot:item.run_to_t="{ item }">
                            {{ item.run_to | formatDate }}
                        </template>
                        <template v-slot:item.run_from_t="{ item }">
                            {{ item.run_from | formatDate }}
                        </template>
                        <template v-slot:item.type_t="{ item }">
                            <span v-show="item.type === 1">
                                % Discount
                            </span>
                            <span v-show="item.type === 2">
                                Buy One Get One
                            </span>
                        </template>
                    </v-data-table>
                    <div class="text-center pt-2">
                        <v-pagination v-model="page" :length="pageCount"></v-pagination>
                    </div>
                </v-flex>
            </v-layout>
        </v-container>

    </div>
</template>


<script>
    import {validationMixin} from 'vuelidate'
    import {required, maxLength, minLength, email} from 'vuelidate/lib/validators'
    import moment from 'moment'

    export default {
        mixins: [validationMixin],

        validations: {
            editedItem: {
                name: {
                    required
                },
                type: {
                    required
                },
                run_to: {
                    required
                },
                run_from: {
                    required
                },
                amount: {
                    required
                }
            }
        },
        components: {},
        data: vm => ({
            headers: [
                {
                    text: 'Name',
                    align: 'left',
                    sortable: false,
                    value: 'name',
                },
                {
                    text: 'Amount',
                    align: 'left',
                    sortable: false,
                    value: 'amount',
                },
                {
                    text: 'Type',
                    align: 'left',
                    sortable: false,
                    value: 'type_t',
                },
                {
                    text: 'Run From',
                    align: 'left',
                    sortable: false,
                    value: 'run_from_t',
                },
                {
                    text: 'Run To',
                    align: 'left',
                    sortable: false,
                    value: 'run_to_t',
                },
                {
                    text: 'Actions',
                    align: 'left',
                    sortable: false,
                    value: 'action',
                },
            ],
            notification_type: 'success',
            notification_message: '',
            notification: false,
            dialog: false,
            promotions: [],
            editedIndex: -1,
            editedItem: {
                name: '',
                amount: 0,
                type: null,
                run_from: '',
                run_to: '',
                products: []
            },
            defaultItem: {
                name: '',
                amount: 0,
                type: 1,
                run_from: '',
                run_to: '',
                products: []
            },
            page: 1, //default load page
            pageCount: 0,
            itemsPerPage: 20, //items shown per page,
            totalItems: 0,
            promo_types: [
                {
                    id: 1,
                    name: 'Percentage Discount'
                },
                {
                    id: 2,
                    name: 'Buy One Get One'
                }
            ],
            menu1: false,
            menu2: false,
            date: new Date().toISOString().substr(0, 10),
            dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
            products: [],
            search_products: null,
            isLoading: false,
            search:{},
            search_url: ''
        }),
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
            },
            checkName() {
                const errors = [];
                if (!this.$v.editedItem.name.$dirty) return errors;
                !this.$v.editedItem.name.required && errors.push('Name is required.');
                return errors;
            },
            checkType() {
                const errors = [];
                if (!this.$v.editedItem.type.$dirty) return errors;
                !this.$v.editedItem.type.required && errors.push('Type is required.');
                return errors;
            },
            checkAmount() {
                const errors = [];
                if (!this.$v.editedItem.amount.$dirty) return errors;
                !this.$v.editedItem.amount.required && errors.push('Amount is required. If Buy One Get One Put 0');
                return errors;
            },
            checkRunFrom() {
                const errors = [];
                if (!this.$v.editedItem.run_from.$dirty) return errors;
                !this.$v.editedItem.run_from.required && errors.push('run_from is required.');
                return errors;
            },
            checkRunTo() {
                const errors = [];
                if (!this.$v.editedItem.run_to.$dirty) return errors;
                !this.$v.editedItem.run_to.required && errors.push('Run to is required.');
                return errors;
            },
        },
        watch: {
            dialog(val) {
                val || this.close()
            },
            page(page_number) {
                this.load_promotions(page_number);
            },
            search_products(val) {

                if (!val || val === '') return;
                if (this.products.length > 0) return;

                if (this.isLoading) return;

                this.isLoading = true;
                console.log('reload');
                this.$http.get(
                    this.$http.defaults.baseURL + '/admin/products/?name=' + val+ this.search_url).then((response) => {
                    this.products = response.data.results;
                    this.isLoading = false;
                })
                    .catch((error) => {
                        // this.notification = false;
                        // this.notification_message = 'Error: Please contact administrator';
                        console.log("Error");
                        console.log(error);
                    }).finally(() => (this.isLoading = false));
            },

        },
        created() {
            this.load_promotions(this.page);
        },
        methods: {
            load_promotions(page_no) {
                let offset = ( page_no - 1) * this.itemsPerPage;
                let limit = this.itemsPerPage;
                this.$http.get(
                    this.$http.defaults.baseURL + '/admin/promotions/?limit=' + limit + '&offset=' + offset).then((response) => {
                    this.promotions = response.data.results;
                    this.notification = false;
                    this.notification_message = '';
                    this.totalItems = (response.data.count / this.itemsPerPage);
                    if(this.products.length < 1)
                    {
                        this.load_products();
                    }
                })
                    .catch((error) => {
                        this.notification = true;
                        this.notification_message = 'Error: Please contact administrator';
                        console.log("Error");
                        console.log(error);
                    });
            },
            load_products() {
                this.$http.get(
                    this.$http.defaults.baseURL + '/admin/products/').then((response) => {
                    this.products = response.data.results;
                })
                    .catch((error) => {
                        this.notification = true;
                        this.notification_message = 'Error: Please contact administrator';
                        console.log("Error");
                        console.log(error);
                    });
            },
            editItem(item) {
                this.editedIndex = this.promotions.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true;
            },

            deleteItem(item) {
                const index = this.promotions.indexOf(item);
                if (confirm('Are you sure you want to delete this item?')) {
                    this.$http.delete(
                        this.$http.defaults.baseURL + '/admin/promotions/' + item.id + '/').then((response) => {
                        this.notification = true;
                        this.notification_message = 'Successfully Deleted';
                        this.promotions.splice(index, 1);

                    })
                        .catch((error) => {
                            this.notification = true;
                            this.notification_type = 'red darken-1';
                            this.notification_message = 'Error: Please contact administrator';
                            console.log("Error");
                            console.log(error);
                        });
                }
            },

            close() {
                this.dialog = false;
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1
                }, 300)
            },

            save() {
                this.$v.$touch();

                if (this.$v.$invalid) {
                    this.notification = true;
                    this.notification_type = 'red darken-2';
                    this.notification_message = 'Please fill the form out correctly';
                    return false;
                }
                let prod_s = [];
                this.editedItem.products.forEach(function(o,i){
                    if(typeof o.id !== 'undefined')
                    {
                        prod_s.push(o.id);
                    } else {
                        prod_s.push(o);
                    }
                });
                this.editedItem.products = prod_s;
                let send_data = {
                    name: this.editedItem.name,
                    type: this.editedItem.type,
                    amount: this.editedItem.amount,
                    run_to: this.formatForSql(this.editedItem.run_to),
                    run_from: this.formatForSql(this.editedItem.run_from),
                    products: this.editedItem.products
                };

                console.log(send_data);

                if (this.editedIndex > -1) {
                    send_data.id = this.editedItem.id;

                    this.$http.patch(
                        this.$http.defaults.baseURL + '/admin/promotions/' + this.editedItem.id + '/', send_data).then((response) => {
                        this.notification = true;
                        this.notification_message = 'Successfully Saved';
                        Object.assign(this.promotions[this.editedIndex], this.editedItem);
                        this.close();
                    })
                        .catch((error) => {
                            this.notification = true;
                            this.notification_type = 'red darken-1';
                            this.notification_message = 'Error: Please contact administrator';
                            console.log("Error");
                            console.log(error);
                        });


                } else {
                    this.$http.post(
                        this.$http.defaults.baseURL + '/admin/promotions/', send_data).then((response) => {
                        this.notification = true;
                        this.notification_message = 'Successfully Saved';
                        this.editedItem.id = response.data.id;

                        // this.promotions.push(this.editedItem);
                        this.load_promotions(1);
                        this.page = 1;
                        this.close()
                    })
                        .catch((error) => {
                            this.notification = true;
                            this.notification_type = 'red darken-1';
                            this.notification_message = 'Error: Please contact administrator';
                            console.log("Error");
                            console.log(error);
                        });

                }
            },
            formatForSql(d) {
                return moment(String(d)).format('YYYY-MM-DDThh:mm')
            },
            formatDate(date) {
                if (!date) return null;

                const [year, month, day] = date.split('-');
                return `${month}/${day}/${year}`
            },
            parseDate(date) {
                if (!date) return null;

                const [month, day, year] = date.split('/');
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            },
            filter_results(search)
            {
                let search_url = '';
                for (let prop in search) {
                    // skip loop if the property is from prototype
                    if(!search.hasOwnProperty(prop)) continue;

                    // your code
                    search_url += '&'+prop+'='+search[prop];
                }
                this.search_url = search_url;
                this.load_promotions(1);
                this.page = 1;
            }
        },
    }
</script>
